// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"547":"42527854e1001cb7","688":"2574a30b0d628ca6"}[chunkId] + ".css";
};